export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/audiobook_production.8a1503b.svg";